module.exports = "<ngx-loading-bar></ngx-loading-bar>\r\n<app-nav-menu></app-nav-menu>"